import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons'
import { Col, Row, Tab, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { openChapters, toArray } from '../common/util';
import {fetchActiveApplications, fetchChapterMembers} from '../redux/actions';
import ApplicationList from '../Applications/ApplicationList';
import RecruitList from './RecruitList';
import {
    applicationSelector, authSelector,
    chapterMemberSelector,
    chapterSelector, rankSelector,
    recruitmentSelector,
    userSelector,
} from "../redux/selectors";
import {hasGroup} from "../common/permissions";

const officerStates = [
        'step_1_submitted',
        'step_1_redo_submitted',
        'step_2_submitted',
        'step_2_redo_submitted',
    ];
const applicantStates = [
        'step_1_redo',
        'step_1_approved',
        'step_1_redo_approved',
        'step_2_redo',
        'step_3_interview',
    ];

class Recruitment extends Component {
    componentDidMount() {
        this.props.getApplications();
        document.title = "Addiction | Recruitment";
        openChapters(this.props.chapters)
            .filter(chapter => chapter.game.title !== "Addiction")
            .map((chapter) => {
                this.props.getChapterMembers(chapter.id);                
                return null;
            });
    }

    render() {
        if (hasGroup('Member',this.props.auth.groups)) {
            return (
                <div>
                    <h1>Recruitment</h1>
                    <div className="panel">
                        <Tab.Container id="recruitment" defaultActiveKey="0-recruitment">
                            <Row className="clearfix">
                                <Col xs={18} md={12}>
                                    <Nav bsStyle="pills">
                                    {
                                        openChapters(this.props.chapters)
                                            .filter(chapter => chapter.game.title !== "Addiction")
                                            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                            .map((chapter, i) => (
                                            <NavItem eventKey={`${i}-recruitment`} key={`${i}-recruitment`}>
                                                <div className="clearfix">
                                                    <h3 className="pull-left">{chapter.game.title} </h3>

                                             {toArray(this.props.recruitment.applications)
                                                    .filter(application => application.state !== "accepted" && application.state !== "rejected" && application.state !== "closed")
                                                    .filter(application => application.chapter === chapter.id).length > 0 ?
                                                (
                                                <div className="pull-right">
                                                    <span className="badge">
                                                        <div className="text-danger ">
                                                            {toArray(this.props.recruitment.applications)
                                                                .filter(application => application.state !== "accepted" && application.state !== "rejected" && application.state !== "closed")
                                                                .filter(application => application.chapter === chapter.id).length} <FontAwesomeIcon icon={faEnvelopeOpen} fixedWidth />
                                                        </div>
                                                    </span>
                                                </div>
                                                ) : ('')
                                             }
                                                </div>
                                            </NavItem>
                                        ))
                                    }
                                    </Nav>
                                </Col>
                                <Col xs={18} md={12}>
                                    <Tab.Content animation>
                                        { openChapters(this.props.chapters)
                                            .filter(chapter => chapter.game.title !== "Addiction")
                                            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                            .map((chapter, i) => (
                                            <Tab.Pane eventKey={`${i}-recruitment`} key={`${i}-recruitment`}>
                                                <div className="panel-adt">
                                                    <h2>Awaiting Officer Review:</h2>
                                                </div>
                                                <ApplicationList applications={
                                                    toArray(this.props.recruitment.applications)
                                                    .filter(application => application.chapter === chapter.id)
                                                    .filter(application => officerStates.includes(application.state))
                                                    .sort((a, b) => (new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime()))
                                                    }
                                                    users={this.props.users}
                                                    location="/recruitment/applications/"
                                                />

                                                <div className="panel-adt">
                                                    <h2>Awaiting Applicant Update:</h2>
                                                </div>
                                                <ApplicationList applications={
                                                    toArray(this.props.recruitment.applications)
                                                    .filter(application => application.chapter === chapter.id)
                                                    .filter(application => applicantStates.includes(application.state))
                                                    .sort((a, b) => (new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime()))
                                                    }
                                                    users={this.props.users}
                                                    location="/recruitment/applications/"
                                                />

                                                <div className="panel-adt">
                                                    <h2>Recruits</h2>
                                                </div>                                                
                                                <RecruitList
                                                    users={this.props.users}
                                                    ranks={this.props.ranks}
                                                    auth={this.props.auth}
                                                    recruits={toArray(this.props.chapterMembers.data)
                                                        .filter(member => member.chapter === chapter.id)
                                                        .filter(member => this.props.users[member.member].rank === 1)
                                                        .sort((a, b) => (new Date(b.joinDate).getTime() - new Date(a.joinDate).getTime()))
                                                        }
                                                />
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
    chapters: chapterSelector(state),
    recruitment: recruitmentSelector(state),
    applications: applicationSelector(state),
    chapterMembers : chapterMemberSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getApplications: (chapter) => dispatch(fetchActiveApplications(chapter)),
    getChapterMembers: (chapter) => dispatch(fetchChapterMembers(chapter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recruitment);


// WEBPACK FOOTER //
// ./src/Recruitment/Recruitment.js